import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhoneFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5523 22.1325C15.1114 22.0795 11.0307 21.5161 6.75735 17.2427C2.48396 12.9693 1.92056 8.88864 1.86754 7.44769C1.78674 5.25223 3.46854 3.11904 5.41215 2.28607C5.86821 2.09061 6.4206 2.12638 6.85728 2.44491C8.45607 3.61113 9.56071 5.37437 10.509 6.76168C10.9374 7.38837 10.835 8.24402 10.2531 8.74774L8.30197 10.1968C8.10858 10.3404 8.04428 10.6014 8.16027 10.8125C8.60172 11.6161 9.38818 12.8119 10.2881 13.7119C11.1891 14.6128 12.4414 15.45 13.3002 15.9412C13.5229 16.0686 13.803 15.9948 13.9438 15.7803L15.2131 13.8469C15.6998 13.1991 16.6088 13.0576 17.2695 13.5149C18.677 14.489 20.3188 15.5737 21.521 17.1133C21.8625 17.5507 21.9133 18.1227 21.7096 18.5981C20.8728 20.5507 18.7552 22.2136 16.5523 22.1325Z",
		fill: "currentColor"
	})
});
export default SvgPhoneFill;
